/* オープニング演出(2026-08-24改)
   参考: saihoji-kokedera.com のローディング。

   タイムライン:
   1. 黒背景の気泡動画(暗幕)が全画面で立ちのぼる
   2. 実物の縦書き見出し「年越しソーダ」が、ぼかしが澄んでいくように
      幕の上へ浮かび上がる
   3. 幕(気泡動画)が抜けてヒーロー動画が現れて終了

   当初はcanvas描画の泡だったが、気泡動画へ差し替えた
   (2026-08-24ユーザー指示、同日中に黒背景版へ変更)。

   - 表示するかどうかはliquid側のインラインスクリプトが決める(is-armed)。
     reduced-motion・テーマエディタ・(設定により)同一セッション2回目は動かない
     (そのときは動画のsrcも与えられず、読み込み自体が発生しない)
   - クリック/キー入力でスキップ(幕の抜けまで早送り)
   - 失敗時(動画が再生できない等)は即座に後始末して通常表示へ戻る */

if (!customElements.get('ny-soda-hero-intro')) {
  // タイムライン(ms)
  const HEADING_IN = 1300; // 見出しが浮かび上がり始める(CSS遷移1.8s)
  const REVEAL = 2900; // 幕が抜け始める(CSS遷移1s、見出しは白へ)
  const END = 4200; // 後始末

  class NySodaHeroIntro extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('is-armed')) return;
      this.hero = this.closest('ny-soda-hero-videos');
      this.video = this.querySelector('video');
      this.done = false;

      this.onSkip = () => this.skip();
      // 見出し(z:60)が幕より前面にあり要素へのクリックが届かない位置が
      // あるため、pointerdownもwindowで拾う
      window.addEventListener('pointerdown', this.onSkip);
      window.addEventListener('keydown', this.onSkip);
      this.failsafe = setTimeout(() => this.cleanup(), 9000);

      this.start();
    }

    disconnectedCallback() {
      window.removeEventListener('pointerdown', this.onSkip);
      window.removeEventListener('keydown', this.onSkip);
      clearTimeout(this.failsafe);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    start() {
      try {
        if (this.video) {
          this.video.muted = true;
          const playing = this.video.play();
          if (playing && playing.catch) {
            // 自動再生が拒否されても、幕の地色だけで演出は成立させる
            playing.catch(() => {});
          }
        }

        this.t0 = performance.now();
        const tick = (now) => {
          if (this.done) return;
          this.frame(now - this.t0);
          this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
      } catch (e) {
        this.cleanup();
      }
    }

    frame(t) {
      if (t >= HEADING_IN && !this.headingIn) {
        this.headingIn = true;
        // 実見出しが幕の上へ、ぼかしが澄んでいくように浮かび上がる(CSS遷移)
        this.hero.classList.add('ny-intro-heading-in');
      }
      if (t >= REVEAL && !this.revealed) {
        this.revealed = true;
        this.classList.add('is-revealed');
        // ヒーロー側(ny-soda-hero-video.js)へ「幕が抜け始めた」を伝える。
        // ヒーローはこの合図で1本目を頭から再生する
        this.hero.classList.add('ny-intro-revealing');
        document.documentElement.classList.remove('ny-intro-lock');
      }
      if (t >= END) {
        this.cleanup();
      }
    }

    skip(force) {
      if (this.done || !this.t0) return;
      if (force === true) {
        this.cleanup();
        return;
      }
      const t = performance.now() - this.t0;
      if (t < REVEAL) this.t0 -= REVEAL - t;
    }

    cleanup() {
      if (this.done) return;
      this.done = true;
      clearTimeout(this.failsafe);
      if (this.raf) cancelAnimationFrame(this.raf);
      window.removeEventListener('pointerdown', this.onSkip);
      window.removeEventListener('keydown', this.onSkip);
      document.documentElement.classList.remove('ny-intro-lock');
      if (this.video) {
        try {
          this.video.pause();
        } catch (e) {
          /* 停止できなくても要素ごと消える */
        }
      }
      if (this.hero) {
        // 後始末の順序: 全クラスを外しても最終状態(白・opacity 1・ぼかしなし)と
        // 一致するため見た目は変わらない
        this.hero.classList.remove('ny-intro-pending');
        this.hero.classList.remove('ny-intro-heading-in');
        this.hero.classList.remove('ny-intro-revealing');
      }
      try {
        window.sessionStorage.setItem('ny-soda-hero-intro-seen', '1');
      } catch (e) {
        /* 保存できなくても支障なし */
      }
      this.remove();
    }
  }

  customElements.define('ny-soda-hero-intro', NySodaHeroIntro);
}
